import { z } from "zod";

export const formSchema = z.object({
    offer: z.string().optional(),
    user: z.string().optional(),
    title: z.string().optional(),
    domain: z.string().min(1, "forms.general-validation.domain_required"),
    url: z.string().optional()
});

export type OfferLinkFormData = z.infer<typeof formSchema>;
